import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { VersionsModule } from '@core/components/versions/versions.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillArtworkLinkSelectorV1FieldComponent } from './fill-artwork-link-selector-v1/fill-artwork-link-selector-v1.component';
import { ViewArtworkLinkSelectorV1FieldComponent } from './view-artwork-link-selector-v1/view-artwork-link-selector-v1.component';
import { SettingsArtworkLinkSelectorV1FieldComponent } from './settings-artwork-link-selector-v1/settings-artwork-link-selector-v1.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        LabelsModule,
        PipesModule,
        VersionsModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillArtworkLinkSelectorV1FieldComponent,
        ViewArtworkLinkSelectorV1FieldComponent,
        SettingsArtworkLinkSelectorV1FieldComponent
    ],
    exports: [
        FillArtworkLinkSelectorV1FieldComponent,
        ViewArtworkLinkSelectorV1FieldComponent,
        SettingsArtworkLinkSelectorV1FieldComponent
    ],

})
export class CoreCustomFormsFieldArtworkLinkSelectorV1FieldsModule { }
